import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import "rxjs/add/operator/filter";
import { Http, Headers, RequestOptions } from "@angular/http";
import {
  state,
  style,
  transition,
  animate,
  trigger,
  AUTO_STYLE,
} from "@angular/animations";
import { fadeInOutTranslate } from "../../shared/elements/animation";
import swal from "sweetalert2";
import { MenuItems } from "../../shared/menu-items/menu-items";
import { GlobalVar } from "../../global-var";
import * as moment from "moment";
import { Router } from "@angular/router";
import OlMap from "ol/map";
import OlTileWMS from "ol/source/TileWMS";
import VectorLayer from "ol/layer/vector";
import OlView from "ol/view";
import Style from "ol/style/style";
import VectorSource from "ol/source/Vector";
import OlTileLayer from "ol/layer/tile";
import { TranslateService } from "../../translate.service";

export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: "app-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.css"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    fadeInOutTranslate,
    trigger("slideInOut", [
      state(
        "in",
        style({
          transform: "translate3d(0, 0, 0)",
        })
      ),
      state(
        "out",
        style({
          transform: "translate3d(100%, 0, 0)",
        })
      ),
      transition("in => out", animate("400ms ease-in-out")),
      transition("out => in", animate("400ms ease-in-out")),
    ]),
    trigger("slideOnOff", [
      state(
        "on",
        style({
          transform: "translate3d(0, 0, 0)",
        })
      ),
      state(
        "off",
        style({
          transform: "translate3d(100%, 0, 0)",
        })
      ),
      transition("on => off", animate("400ms ease-in-out")),
      transition("off => on", animate("400ms ease-in-out")),
    ]),
    trigger("mobileMenuTop", [
      state(
        "no-block, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "yes-block",
        style({
          height: AUTO_STYLE,
        })
      ),
      transition("no-block <=> yes-block", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class AdminLayoutComponent implements OnInit {
  deviceType = "desktop";
  verticalNavType = "expanded";
  lang = localStorage.getItem("lang");
  verticalEffect = "shrink";
  chatToggle = "out";
  chatInnerToggle = "off";
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = "no-block";
  toggleOn = true;
  windowWidth: number;
  IsLoggedIn = true;
  username;
  user_role;
  this_year;
  color_indicated;
  logo_name;
  server;
  config_data;
  realtime_data = [];
  realtime_key;
  selected_searchvalue;
  web_role = localStorage.getItem("web");
  mapz: OlMap;
  sourcez: OlTileWMS;
  layerz;
  viewz: OlView;
  styles: Style;
  markerSourceUni: VectorSource;
  r_lat = 0;
  r_lon = 0;
  r_status = "";
  headding = 0;
  pdpa = localStorage.getItem("pdpa_flag")
  onPdpa = false
  change_pdpa = false
  node_server = localStorage.getItem("node_server");
  @ViewChild("searchFriends") search_friends: ElementRef;
  @ViewChild("toggleButton") toggle_button: ElementRef;
  @ViewChild("sideMenu") side_menu: ElementRef;
  constructor(
    private _g: GlobalVar,
    public menuItems: MenuItems,
    private _http: Http,
    private router: Router,
    private translate: TranslateService
  ) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + "px";
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
    // this._g.hosts = "http://localhost:1000/";
    // this._g.hosts = "http://203.151.70.147:3010/";
    // console.log('11',this._g.server)
    // this._g.hosts = "http://10.255.248.91:3003/";
    // this._g.hosts = "http://localhost:3003/";
    this._g.hosts = this._g.server
    this.server =
      this._g.server == null
        ? null
        : this._g.server.split("//")[1].split(":")[0];
    let date = new Date();
    console.log(this._g.hosts);

    this.this_year = date.getFullYear();
    this.translate.use(this.lang.toLowerCase());
    this._g.usernames = localStorage.getItem("node_user");
    this.username =
      localStorage.getItem("node_user") == "null"
        ? ""
        : localStorage.getItem("node_user");
    this.user_role = localStorage.getItem("node_role");
    this.logo_name = "IVMS-PRO";
  }

  ngOnInit() {
    if (this.router.url == "/dashboard") {
      this.verticalNavType = "collapsed";
    } else {
      this.verticalNavType = "expanded";
    }
  }

  menuControl() {
    if (this.router.url == "/dashboard") {
      this.verticalNavType = "collapsed";
    } else {
      this.verticalNavType = "expanded";
    }
  }
  onClickedOutside(e: Event) {
    //   if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
    //     debugger
    //       this.toggleOn = true;
    //       this.verticalNavType = 'offcanvas';
    //   }5
  }

  setLang(lang: string) {
    this.translate.use(lang.toLowerCase());
    this.lang = lang.toUpperCase();
    localStorage.setItem("lang", lang.toUpperCase());
    location.reload();
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + "px";
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = "tablet";
      this.verticalNavType = "collapsed";
      this.verticalEffect = "push";
    } else if (windowWidth < 768) {
      this.deviceType = "mobile";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else {
      this.deviceType = "desktop";
      this.verticalNavType = "expanded";
      this.verticalEffect = "shrink";
    }
  }
  getevent(x) {
    console.log(x);
  }

  searchFriendList(event) {
    const search = this.search_friends.nativeElement.value.toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll(
      ".userlist-box .media-body .chat-header"
    );
    Array.prototype.forEach.call(friendList, function (elements, index) {
      search_input = elements.innerHTML.toLowerCase();
      search_parent = elements.parentNode.parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add("show");
        search_parent.classList.remove("hide");
      } else {
        search_parent.classList.add("hide");
        search_parent.classList.remove("show");
      }
    });
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === "out" ? "in" : "out";
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === "off" ? "on" : "off";
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn =
        this.verticalNavType === "offcanvas" ? true : this.toggleOn;
      this.verticalNavType =
        this.verticalNavType == "expanded" ? "offcanvas" : "expanded";
      // console.log(this.verticalNavType);
    } else {
      this.verticalNavType =
        this.verticalNavType === "expanded" ? "collapsed" : "expanded";
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile =
      this.isCollapsedMobile === "yes-block" ? "no-block" : "yes-block";
  }

  onScroll(event) {
    this.isScrolled = false;
  }
  loggedout() {
    if (this.lang == "TH") {
      swal({
        title: "คุณต้องการออกจากระบบใช่ไหม",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#26f01f",
        cancelButtonColor: "#727272",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then(() => {
        let temp = localStorage.getItem("last_user");
        localStorage.clear();
        swal({
          title: "ออกจากระบบ",
          text: "คุณได้ออกจากระบบแล้ว",
          type: "success",
          allowOutsideClick: false,
        }).then(() => {
          localStorage.clear();
          location.assign("/cameraLogin");
        });
      });
    } else if (this.lang == "EN") {
      swal({
        title: "Do you want to logout?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#26f01f",
        cancelButtonColor: "#727272",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then(() => {
        let temp = localStorage.getItem("last_user");
        localStorage.clear();
        swal({
          title: "Logout!",
          type: "success",
          allowOutsideClick: false,
        }).then(() => {
          localStorage.clear();
          location.assign("/cameraLogin");
        });
      });
    }
  }
  intitialmap() {
    setTimeout(() => {
      this.markerSourceUni = new VectorSource({
        features: [],
      });
      var vectorLayer = new VectorLayer({
        source: this.markerSourceUni,
      });

      this.layerz = new OlTileLayer({
        source: this._g.source,
      });

      this.viewz = new OlView({
        center: [100.6037284, 13.6768896], // lon lat
        zoom: 10,
        projection: "EPSG:4326",
        minZoom: 5,
        maxZoom: 20,
      });

      this.mapz = new OlMap({
        target: "maptab",
        layers: [this.layerz, vectorLayer],
        view: this.viewz,
      });
      this.mapz.render();
    }, 100);
  }

  update_pdpa() {
    let username = localStorage.getItem("node_user")
    this._http
      .post(this.node_server + "update_pdpa", {username: username})
      // .post('http://localhost:3003/' + "update_pdpa", {username: username})
      .subscribe((data) => {
        this.onPdpa = false
        localStorage.setItem("pdpa_flag",'1')
        this.pdpa = localStorage.getItem("pdpa_flag")
      });
  }
  
  on_pdpa() {
    this.onPdpa = !this.onPdpa
  }

}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/layouts/admin/admin-layout.component.ts